module.exports = __webpack_public_path__ + "static/media/zip-icon.63b6592d.svg";